module.exports = __webpack_public_path__ + "img/SimboloCastilloRojoCorporativa.86f7b054.svg";